import React from 'react';
import { useBrand } from '../../../app/config/brand';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  required?: boolean;
  className?: string;
}

export const Input: React.FC<InputProps> = ({ label, required, className = '', id: propId, ...props }) => {
  const brand = useBrand();
  const generatedId = React.useId();
  const id = propId || generatedId;
  return (
    <div className={className}>
      {label && (
        <label htmlFor={id} className="block text-sm font-medium mb-1.5" style={{ color: brand.colors.text }}>
          {required && <span style={{ color: brand.colors.error }}>* </span>}{label}
        </label>
      )}
      <input
        id={id}
        className="w-full px-4 py-2.5 rounded-lg border text-sm focus:outline-hidden focus:ring-2 transition-all"
        style={{ borderColor: brand.colors.border }}
        {...props}
      />
    </div>
  );
};
